import { PlatformKey } from "./types";

// ---- formatting helpers -----------------------------------------------------

export const fmtN = (n: number | null | undefined) => (n == null ? "—" : n.toLocaleString());

export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ${m % 60}m`;
  return `${Math.round(h / 24)} days`;
}

export function fmtDay(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });
}

export const pctOf = (a: number | null | undefined, b: number | null | undefined) =>
  a != null && b != null && b > 0 ? `${Math.round((a / b) * 100)}%` : "—";

// Product-language names for the raw screen/event values the client sends.
export const SCREEN_LABELS: Record<string, string> = {
  landing: "Home page",
  dj_page: "A DJ's page",
  welcome_tour: "Welcome tour",
  signup: "Sign-up",
  invite_code: "Invite-code step",
  app_opened: "App open (no screen seen)",
  landing_viewed: "Landing",
  path_selected: "Path chooser",
  signup_started: "Sign-up start",
  signup_step_completed: "A sign-up step",
  onboarding_started: "Onboarding start",
  onboarding_step_completed: "An onboarding step",
  onboarding_completed: "Onboarding finish",
};
export const screenLabel = (raw: string) => SCREEN_LABELS[raw] || raw.replace(/_/g, " ");

export const SHORT_STEP: Record<string, string> = {
  path_selected: "Chose path",
  signup_started: "Started signup",
  account_created: "Page live",
  DJ_activated: "Bank connected",
  DJ_approved: "Approved",
  Fan_activated: "Activated",
};

export const PLATFORM_LABEL: Record<PlatformKey, string> = { all: "All", web: "Website", app: "App" };
export const PLATFORM_NOTE: Record<PlatformKey, string> = {
  all: "web + app together · every step counts distinct people, not raw events",
  web: "web + desktop only · distinct people",
  app: "iOS + Android only · distinct people",
};
